<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('dashboard.salary-report') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('dashboard.salary-report') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<div class="pull-right">
								<div>
				                  <el-autocomplete
				                          v-model="consultant"
				                          :fetch-suggestions="querySearchUser"
				                          :placeholder="$t('vendor.contract.sp-ph')"
				                          @select="handleSelectUser"
				                          style="width:300px; margin-right:5px;"
				                          :clearable="true"
				                        >
				                      <template slot-scope="{ item }">
				                        <div class="todo todo-default">
				                          <div class="sm-avater list-avater">
				                            <img :src="item.avatar" class="img-responsive img-circle" alt="">
				                          </div>
				                          <h5 class="ct-title">{{ item.name }}<span class="ct-designation">{{ item.title }}@{{ getPractice(item.practiceId) }}</span></h5>
				                        </div>
				                      </template>
				                  </el-autocomplete>
								  <el-date-picker
							      v-model="dateRange"
							      type="daterange"
							      value-format="yyyy-MM-dd"
							      ref="dateRange">
							    </el-date-picker>
							  </div>
							</div>
							<h5 class="mb-0">
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel"></el-button>
								</el-tooltip>
								<el-tooltip :content="$t('dashboard.refresh')" placement="top">
									<el-button type="text" class="el-icon-refresh" @click="refreshData"></el-button>
								</el-tooltip>
							</h5>
						</div>
						<div class="card-body">
							<el-table
							id="salary-sheet"
						    ref="filterTable"
						    :data="salaries"
						    style="width: 100%"
						    >
						    <el-table-column
						      prop="cName"
						      :label="$t('profile.c-name')"
						      width="100"
						      column-key="eName"
						      align="center"
						      fixed
						    >
						    </el-table-column>
						    <el-table-column
						      prop="base"
						      :label="$t('profile.base')"
						      width="100"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="allowance2"
						      :label="$t('profile.allowance-nb')"
						      width="100"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="sHousing"
						      :label="$t('profile.s-housing-c')"
						      width="100"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      :label="$t('salary.housing')"
						      align="center">
						      <el-table-column
						          prop="housingC"
						          :label="$t('salary.company')"
						          width="80"
						          align="center">
						        </el-table-column>
						        <el-table-column
						          prop="housingP"
						          :label="$t('salary.personal')"
						          width="80"
						          align="center">
						        </el-table-column>
						    </el-table-column>
						    <el-table-column
						      :label="$t('salary.pension')"
						      align="center">
						      <el-table-column
						          prop="pensionC"
						          :label="$t('salary.company')"
						          width="80"
						          align="center">
						        </el-table-column>
						        <el-table-column
						          prop="pensionP"
						          :label="$t('salary.personal')"
						          width="80"
						          align="center">
						        </el-table-column>
						    </el-table-column>
						    <el-table-column
						      :label="$t('salary.medical')"
						      align="center">
						      <el-table-column
						          prop="medicalC"
						          :label="$t('salary.company')"
						          width="80"
						          align="center">
						        </el-table-column>
						        <el-table-column
						          prop="medicalP"
						          :label="$t('salary.personal')"
						          width="80"
						          align="center">
						        </el-table-column>
						    </el-table-column>
						    <el-table-column
						      :label="$t('salary.unemployment')"
						      align="center">
						      <el-table-column
						          prop="unemploymentC"
						          :label="$t('salary.company')"
						          width="80"
						          align="center">
						        </el-table-column>
						        <el-table-column
						          prop="unemploymentP"
						          :label="$t('salary.personal')"
						          width="80"
						          align="center">
						        </el-table-column>
						    </el-table-column>
						    <el-table-column
						      prop="injury"
						      :label="$t('profile.injury')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="maternity"
						      :label="$t('profile.maternity')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="disabled"
						      :label="$t('profile.disabled')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="welfare"
						      :label="$t('profile.welfare')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="subsidy"
						      :label="$t('profile.subsidy')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="serviceFee"
						      :label="$t('profile.service-fee')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="serviceFeeNb"
						      :label="$t('profile.service-fee-nb')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="vat"
						      :label="$t('profile.vat-sd')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="vatNb"
						      :label="$t('profile.vat-nb')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="expenseP"
						      :label="$t('salary.expense-p')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="expenseC"
						      :label="$t('salary.expense-c')"
						      width="80"
						      align="center">
						    </el-table-column>
						    <el-table-column
						      prop="countDate"
						      :label="$t('salary.count-date')"
						      width="120"
						      align="center">
						    </el-table-column>
						  </el-table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--Salary Modal -->
		
	</div>
</template>
<script>
// @ is an alias to /src
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'SalaryList',
  components: {
  },
  data: function() {
	return {
	  salaries: [],
	  dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')],
	  consultants: [],
      consultantId: null,
      consultant: null
	}
  },
  watch: {
    dateRange: function(val) {
      this.refreshData()
    },
    consultantId: function(val) {
      this.refreshData()
    }
  },
  methods: {
    querySearchUser: function(queryString, cb) {
      let that = this,
        query = '?userId=' + localStorage.getItem('token') + '&q=' + encodeURI(queryString) + '&_=' + Date.parse(new Date())

      this.$http.get(this.API3_PREFIX + 'users_list' + query).then(function (response) {
        that.consultants = response.data
        cb(that.consultants)
      }).catch(function (error) {
        console.log(error)
      })
    },
    handleSelectUser: function(item) {
      this.consultantId = item.id
      this.consultant = item.name
    },
    refreshData: function() {
      this.loadData()
    },
    exportExcel () {
	  let wb = XLSX.utils.table_to_book(document.querySelector('#salary-sheet'))
	  /* get binary string as output */
	  let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
	  try {
	    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-SalarySheet-' + this.countDate + '.xlsx')
	  } catch (e) {
	    if (typeof console !== 'undefined')
	      console.log(e, wbout)
	  }
	  return wbout
    },
    confirmSalary: function() {
      //save and create account payable
    },
    editSalary: function(row, column, event) {
      this.currentSalary = row
      this.showSalaryForm = true
    },
    loadData: function() {
      let startDate = this.dateRange[0],
          endDate = this.dateRange[1],
          query = '?userId=' + localStorage.getItem('token') + '&startDate=' + startDate + '&endDate=' + endDate,
          that = this,
          loading = Loading.service({ fullscreen: true })
      if (this.consultantId != null)
        query += '&consultantId=' + this.consultantId

	  this.$http.get(this.API3_PREFIX + 'salary_report' + query).then(function (response) {
		that.salaries = response.data
		that.$nextTick(() => {
          loading.close()
        })
      }).catch(function (error) {
		console.log(error)
		that.$nextTick(() => {
          loading.close()
        })
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>